export default __webpack_public_path__ + "locales/de/Webhooks.json?hash=852c41a1266e35f333a36b34c0b61807";